import type { Device } from 'src/types/Device';
import { api } from './api';
import type { PaginatedListResponse } from './response_models/PaginatedListIResponse';

interface DeviceListRequestParams {
  page?: number;
  pageSize?: number;
  searchText?: string;
}

export const devicesApi = api.injectEndpoints({
  endpoints: builder => ({
    getDevicesList: builder.query<PaginatedListResponse<Device>, DeviceListRequestParams>({
      query: ({ page, pageSize, searchText }) => ({
        url: `devices/list_devices_details/`,
        method: 'GET',
        params: { page, page_size: pageSize, search: searchText },
      }),
    }),
    activateDevice: builder.mutation<void, { device_id: string; activate: boolean }>({
      query: payload => ({
        url: `devices/activate_device/`,
        method: 'PATCH',
        body: payload,
      }),
    }),
    registerDevice: builder.mutation<void, { serial_number: string; organization: string }>({
      query: payload => ({
        url: 'devices/register_device/',
        method: 'POST',
        body: payload,
      }),
    }),
    updateDevice: builder.mutation<void, { device_id: string; data: Partial<Device> }>({
      query: ({ device_id, data }) => ({
        url: `devices/update_device/${device_id}/`,
        method: 'PATCH',
        body: data,
      }),
    }),
    deleteDevice: builder.mutation<void, { device_id: string }>({
      query: ({ device_id }) => ({
        url: `devices/update_device/${device_id}/`,
        method: 'DELETE',
      }),
    }),
    assignVehicle: builder.mutation<void, { serial_number: string; vehicle_id: string }>({
      query: payload => ({
        url: `devices/assign_vehicle/${payload.vehicle_id}/`,
        method: 'PATCH',
        body: { device_serial_number: payload.serial_number },
      }),
    }),
    assignDrivers: builder.mutation<void, { vehicle_id: string; driver_ids: string[] | null }>({
      query: payload => ({
        url: `devices/assign_drivers/${payload.vehicle_id}/`,
        method: 'PATCH',
        body: { driver_ids: payload.driver_ids },
      }),
    }),
    listAllDevices: builder.query<Partial<{ results: Device[] }>, void>({
      query: () => 'devices/list_devices/',
    }),
  }),
});

export const {
  useLazyGetDevicesListQuery,
  useActivateDeviceMutation,
  useRegisterDeviceMutation,
  useUpdateDeviceMutation,
  useDeleteDeviceMutation,
  useAssignVehicleMutation,
  useAssignDriversMutation,
  useLazyListAllDevicesQuery,
} = devicesApi;
